import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import './index.scss';
import 'react-toastify/dist/ReactToastify.css';

import './i18n';

import { store } from 'src/store';

import Widget from './Widget';

const root = ReactDOM.createRoot(document.getElementById('widget') as HTMLElement);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Widget />
    </BrowserRouter>
  </Provider>
);
